/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notify_WhenInputs */

const en_notify_when = /** @type {(inputs: Notify_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When`)
};

const de_notify_when = /** @type {(inputs: Notify_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann`)
};

/**
* | output |
* | --- |
* | "When" |
*
* @param {Notify_WhenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notify_when = /** @type {((inputs?: Notify_WhenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notify_WhenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_notify_when(inputs)
	return en_notify_when(inputs)
});